module.exports = __webpack_public_path__ + "media/images/pages/ic-search-641178600f56ba8a61417fb83d6447e1.png";